export const romeToday = () => new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit",
}).format(new Date());

export const addDays = (iso, amount) => {
  const [year, month, day] = iso.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day + amount));
  return date.toISOString().slice(0, 10);
};

export const mondayOf = (iso) => {
  const date = new Date(`${iso}T12:00:00Z`);
  return addDays(iso, -((date.getUTCDay() + 6) % 7));
};

export const italianDay = (iso, long = false) => {
  const date = new Date(`${iso}T12:00:00Z`);
  return new Intl.DateTimeFormat("it-IT", { weekday: long ? "long" : "short", day: "numeric", timeZone: "UTC" }).format(date).toUpperCase();
};

export const minutesTime = (minutes) => `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
export const toPercent = (minutes) => `${((minutes - 540) / 600) * 100}%`;